import { useReducer } from 'react';
import {
  InitialState,
  ModalAction,
  ModalActions,
  ModalProviderProps,
} from '@Hooks/modalManager/modal.types.ts';
import { modalContext } from './modalContext.ts';
import { ModalRenderer } from '@Hooks/modalManager/ModalRenderer.tsx';
import { initialState } from '@Hooks/modalManager/mondal.consts.ts';

const modalReducer = (state: InitialState, action: ModalAction): InitialState => {
  switch (action.type) {
    case ModalActions.SET_MODAL:
      return { ...state, ...action.payload };

    default:
      return state;
  }
};

export const ModalProvider = ({ children }: ModalProviderProps) => {
  const [state, dispatch] = useReducer(modalReducer, initialState);

  const setModal = (modalConfig: Partial<InitialState>) => {
    dispatch({
      type: ModalActions.SET_MODAL,
      payload: { ...modalConfig },
    });
  };

  return (
    <modalContext.Provider value={{ state, setModal }}>
      {children}
      <ModalRenderer />
    </modalContext.Provider>
  );
};
